class ModeManager {
	private forceNSFWModeSwitch?: 'sfw' | 'nsfw' = undefined;

	setForceModeSwitch = (nsfwMode: 'sfw' | 'nsfw' | undefined) => {
		this.forceNSFWModeSwitch = nsfwMode;
	};

	getForceModeSwitch = () => {
		return this.forceNSFWModeSwitch;
	};
}

export const AppModeManager = new ModeManager();
